import { render, staticRenderFns } from "./HighlightedTopProvider.vue?vue&type=template&id=8fb13b6c&scoped=true"
import script from "./HighlightedTopProvider.vue?vue&type=script&lang=js"
export * from "./HighlightedTopProvider.vue?vue&type=script&lang=js"
import style0 from "./HighlightedTopProvider.vue?vue&type=style&index=0&id=8fb13b6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fb13b6c",
  null
  
)

export default component.exports